/**
 * @fileoverview Character Count Display Component
 * 
 * Displays character and word count with limit indicators
 */

import React from 'react';

/**
 * Character Count Display Component
 * 
 * @param {Object} props - Component props
 * @param {number} props.characterCount - Current character count
 * @param {number} [props.wordCount] - Current word count (optional)
 * @param {number} props.maxLength - Maximum character limit
 * @param {string} props.testId - Test ID
 */
const CharacterCountDisplay = ({ characterCount, wordCount, maxLength, testId }) => {
  
  // Calculate percentage of limit used
  const percentage = (characterCount / maxLength) * 100;
  
  // Determine status based on percentage
  const getStatus = () => {
    if (percentage >= 100) return 'error';
    if (percentage >= 90) return 'warning';
    if (percentage >= 75) return 'caution';
    return 'normal';
  };

  const status = getStatus();

  return (
    <div className={`character-count-display ${status}`} data-testid={testId}>
      <div className="count-info">
        <span className="character-count" data-testid={`${testId}-characters`}>
          {characterCount.toLocaleString()} / {maxLength.toLocaleString()} characters
        </span>
        
        {wordCount !== null && wordCount !== undefined && (
          <span className="word-count" data-testid={`${testId}-words`}>
            • {wordCount.toLocaleString()} words
          </span>
        )}
      </div>
      
      <div className="progress-bar" data-testid={`${testId}-progress`}>
        <div 
          className={`progress-fill ${status}`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      
      {status === 'warning' && (
        <div className="status-message warning" data-testid={`${testId}-warning`}>
          Approaching character limit
        </div>
      )}
      
      {status === 'error' && (
        <div className="status-message error" data-testid={`${testId}-error`}>
          Character limit exceeded
        </div>
      )}
    </div>
  );
};

export { CharacterCountDisplay };